/**
 * mSTEM theme application helper. Applies a theme by swapping a single CSS
 * class on <html>. Theme overrides live in src/css/colors.css under the
 * .mstem-theme-dark and .mstem-theme-cyan blocks (added by Plan 02-02).
 *
 * Light is the default — no class needed visually, but we still apply the
 * 'mstem-theme-light' class for explicit selector matching + screenshots.
 *
 * Security note (T-02-01-02): applyTheme validates themeId against
 * VALID_THEMES allowlist before touching classList. A tampered
 * localStorage.mstem.theme value (e.g. "evil onerror=...") cannot inject
 * arbitrary class strings.
 *
 * Block category colors (Motion blue, Looks purple, etc.) live in
 * openblock-blocks JS constants and intentionally do NOT respond to theme
 * swap — per Phase 1 D-06 lock. Only chrome (menu bar, modals, tables,
 * panels) reacts to theme switch.
 */

const DEFAULT_THEME = 'light';
const VALID_THEMES = ['light', 'dark', 'cyan'];
const THEME_CLASSES = VALID_THEMES.map(id => `mstem-theme-${id}`);

const applyTheme = function (themeId) {
    if (typeof document === 'undefined' || !document.documentElement) {
        return;
    }
    let resolved = themeId;
    if (VALID_THEMES.indexOf(resolved) === -1) {
        resolved = DEFAULT_THEME;
    }
    const root = document.documentElement;
    THEME_CLASSES.forEach(cls => {
        root.classList.remove(cls);
    });
    root.classList.add(`mstem-theme-${resolved}`);
};

export {
    applyTheme,
    DEFAULT_THEME,
    VALID_THEMES
};
